import { useNavigate } from "react-router-dom"

export default function useViewTransition() {
  const navigate = useNavigate()

  return (to: string) => {
    const startVT = (document as any).startViewTransition?.bind(document)

    if (!startVT) {
      navigate(to)
      return
    }

    startVT(() => {
      requestAnimationFrame(() => {
        navigate(to)
      })
    })
  }
}